if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
        try {
            this.cartNotification.renderContents(response);
          } catch (err) {
            console.error("Error in renderContents:", err);
            this.refreshCartDrawerFallback();
          }
        })
        .catch((e) => {
          console.error(e);
          this.refreshCartDrawerFallback();
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

 window.refreshCartDrawerFallback = function() {
        console.log("Using fallback cart drawer refresh");

        // Wait a bit for the cart to be updated on server
        setTimeout(() => {
          fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          })
            .then((response) => response.json())
            .then((cartData) => {
              // Update cart count
              const cartCountElements = document.querySelectorAll(".cart-count-bubble span, .cart-count, [data-cart-count]");
              cartCountElements.forEach((el) => {
                if (el) el.textContent = cartData.item_count;
              });

              // Show cart drawer if it exists
              const cartDrawer = document.querySelector(".new_cart_drawer");
              if (cartDrawer) {
                cartDrawer.classList.add("is-active", "is-visible");
                document.documentElement.style.overflow = "hidden";
              }

              // Trigger cart drawer refresh if functions exist
              if (typeof updatelineitem === "function") {
                document.querySelectorAll(".drawer_item").forEach((item) => item.remove());
                updatelineitem(cartData);
              }
              if (typeof updatedrawer === "function") {
                updatedrawer(cartData);
              }
              if (typeof cartcheck === "function") {
                cartcheck(cartData);
              }

              console.log("Cart drawer refreshed successfully");
            })
            .catch((error) => {
              console.error("Fallback cart refresh failed:", error);
            });
        }, 800);
      }